import { Box, MenuItem, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { AddedToCollectionButton } from '../../AddedToCollectionButton';
import { RemoveFromCollectionButton } from '../../RemoveFromCollectionButton';

interface CollectionListItemProps {
  id: string;
  name: string;
  addToCollection: (id: string, name: string) => void;
  isFeedbackPartOfCollection: boolean;
  removeFromCollection: (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string,
    name: string,
  ) => void;
}

export const CollectionListItem = ({
  id,
  name,
  addToCollection,
  removeFromCollection,
  isFeedbackPartOfCollection = false,
}: CollectionListItemProps) => {
  const [isItemHovered, setIsItemHovered] = useState(false);

  return (
    <MenuItem
      key={id}
      onClick={() => addToCollection(id, name)}
      sx={{
        color: isFeedbackPartOfCollection ? 'text.disabled' : 'text.primary',
      }}
      onMouseOver={() => setIsItemHovered(true)}
      onMouseOut={() => setIsItemHovered(false)}
      tabIndex={0}
    >
      <Stack
        justifyContent="space-between"
        alignItems="center"
        direction="row"
        width="100%"
      >
        <Typography noWrap sx={{ flex: 1 }}>
          {name}
        </Typography>
        {isFeedbackPartOfCollection && (
          <Box>
            {isItemHovered ? (
              <RemoveFromCollectionButton
                removeFromCollection={(event) =>
                  removeFromCollection(event, id, name)
                }
              />
            ) : (
              <AddedToCollectionButton />
            )}
          </Box>
        )}
      </Stack>
    </MenuItem>
  );
};
